// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__dLPMx","icon":"styles_icon__es8Y7","label":"styles_label__Ab89k"};